import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, SpotDto, SpotReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import SpotInline, { SpotInlineProps } from "./SpotInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: SpotDto | SpotReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<SpotInlineProps>;
}

export default function SpotLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.SpotRead]}
      to={ROUTE_PATH.SPOT_VIEW(entity?.id || entityId || "")}
      content={<SpotInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
